export default (props, e) => {
  e.preventDefault();
  const dropdown = document.getElementById('js_fulltextDropdown');
  const fultextFilter = document.getElementById('facultyCategory');
  const fulltextResults = document.getElementById('result');
  dropdown.classList.toggle('opened');
  fultextFilter.selectedIndex  = '0';
  if (fulltextResults) {
    fulltextResults.style.display = "none";
  }
  //fultextFilter.parentElement.style.display = "none";
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/headerNavDropdownClose.js